import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.css';

const MatchedHeaderSparkleIcon = () => (
  <svg width='22' height='22' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <path d='M8 1l1.6 4.4L14 7l-4.4 1.6L8 13l-1.6-4.4L2 7l4.4-1.6z' fill='#74CCD3' />
    <path d='M13 11l.6 1.4L15 13l-1.4.6L13 15l-.6-1.4L11 13l1.4-.6z' fill='#74CCD3' opacity='0.7' />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox='0 0 18 18' width='18' height='18' aria-hidden='true'>
    <path d='M4 4l10 10M14 4L4 14' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
  </svg>
);

const VerifiedMentorIcon = () => (
  <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <path
      d='M10.5872 4.81969C10.4105 4.635 10.2277 4.44469 10.1588 4.27734C10.095 4.12406 10.0912 3.87 10.0875 3.62391C10.0805 3.16641 10.073 2.64797 9.7125 2.2875C9.35203 1.92703 8.83359 1.91953 8.37609 1.9125C8.13 1.90875 7.87594 1.905 7.72266 1.84125C7.55578 1.77234 7.365 1.58953 7.18031 1.41281C6.85687 1.10203 6.48938 0.75 6 0.75C5.51062 0.75 5.14359 1.10203 4.81969 1.41281C4.635 1.58953 4.44469 1.77234 4.27734 1.84125C4.125 1.905 3.87 1.90875 3.62391 1.9125C3.16641 1.91953 2.64797 1.92703 2.2875 2.2875C1.92703 2.64797 1.92188 3.16641 1.9125 3.62391C1.90875 3.87 1.905 4.12406 1.84125 4.27734C1.77234 4.44422 1.58953 4.635 1.41281 4.81969C1.10203 5.14313 0.75 5.51062 0.75 6C0.75 6.48938 1.10203 6.85641 1.41281 7.18031C1.58953 7.365 1.77234 7.55531 1.84125 7.72266C1.905 7.87594 1.90875 8.13 1.9125 8.37609C1.91953 8.83359 1.92703 9.35203 2.2875 9.7125C2.64797 10.073 3.16641 10.0805 3.62391 10.0875C3.87 10.0912 4.12406 10.095 4.27734 10.1588C4.44422 10.2277 4.635 10.4105 4.81969 10.5872C5.14313 10.898 5.51062 11.25 6 11.25C6.48938 11.25 6.85641 10.898 7.18031 10.5872C7.365 10.4105 7.55531 10.2277 7.72266 10.1588C7.87594 10.095 8.13 10.0912 8.37609 10.0875C8.83359 10.0805 9.35203 10.073 9.7125 9.7125C10.073 9.35203 10.0805 8.83359 10.0875 8.37609C10.0912 8.13 10.095 7.87594 10.1588 7.72266C10.2277 7.55578 10.4105 7.365 10.5872 7.18031C10.898 6.85687 11.25 6.48938 11.25 6C11.25 5.51062 10.898 5.14359 10.5872 4.81969ZM8.14031 5.14031L5.51531 7.76531C5.48049 7.80018 5.43913 7.82784 5.3936 7.84671C5.34808 7.86558 5.29928 7.87529 5.25 7.87529C5.20072 7.87529 5.15192 7.86558 5.1064 7.84671C5.06087 7.82784 5.01951 7.80018 4.98469 7.76531L3.85969 6.64031C3.78932 6.56995 3.74979 6.47451 3.74979 6.375C3.74979 6.27549 3.78932 6.18005 3.85969 6.10969C3.93005 6.03932 4.02549 5.99979 4.125 5.99979C4.22451 5.99979 4.31995 6.03932 4.39031 6.10969L5.25 6.96984L7.60969 4.60969C7.64453 4.57485 7.68589 4.54721 7.73141 4.52835C7.77694 4.5095 7.82573 4.49979 7.875 4.49979C7.92427 4.49979 7.97306 4.5095 8.01859 4.52835C8.06411 4.54721 8.10547 4.57485 8.14031 4.60969C8.17515 4.64453 8.20279 4.68589 8.22165 4.73141C8.2405 4.77694 8.25021 4.82573 8.25021 4.875C8.25021 4.92427 8.2405 4.97306 8.22165 5.01859C8.20279 5.06411 8.17515 5.10547 8.14031 5.14031Z'
      fill='#188F8B'
    />
  </svg>
);

const ChatIcon = ({ className }) => (
  <svg
    className={className}
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M8.99964 1.6875C7.73716 1.68722 6.49611 2.01381 5.39729 2.63547C4.29847 3.25714 3.37932 4.15269 2.7293 5.23498C2.07927 6.31726 1.72053 7.5494 1.68798 8.81146C1.65543 10.0735 1.95018 11.3225 2.54355 12.4369L1.7455 14.831C1.6794 15.0292 1.6698 15.242 1.7178 15.4453C1.76579 15.6487 1.86947 15.8347 2.01723 15.9824C2.16498 16.1302 2.35096 16.2339 2.55433 16.2818C2.75769 16.3298 2.97041 16.3202 3.16863 16.2541L5.56277 15.4561C6.54347 15.9777 7.63011 16.269 8.74021 16.308C9.85031 16.347 10.9547 16.1325 11.9695 15.6809C12.9844 15.2293 13.883 14.5525 14.5972 13.7017C15.3114 12.851 15.8224 11.8487 16.0914 10.771C16.3605 9.69326 16.3804 8.56842 16.1498 7.48184C15.9192 6.39525 15.4441 5.37549 14.7605 4.49994C14.0769 3.6244 13.2029 2.91608 12.2047 2.42877C11.2065 1.94146 10.1104 1.68796 8.99964 1.6875ZM5.90589 9.84375C5.73902 9.84375 5.57588 9.79426 5.43713 9.70155C5.29838 9.60884 5.19023 9.47706 5.12637 9.32289C5.06251 9.16871 5.0458 8.99906 5.07836 8.83539C5.11091 8.67172 5.19127 8.52138 5.30927 8.40338C5.42727 8.28538 5.57761 8.20502 5.74129 8.17246C5.90496 8.13991 6.07461 8.15662 6.22878 8.22048C6.38296 8.28434 6.51473 8.39248 6.60745 8.53124C6.70016 8.66999 6.74964 8.83312 6.74964 9C6.74964 9.22378 6.66075 9.43839 6.50251 9.59662C6.34428 9.75486 6.12967 9.84375 5.90589 9.84375ZM8.99964 9.84375C8.83276 9.84375 8.66963 9.79426 8.53088 9.70155C8.39213 9.60884 8.28398 9.47706 8.22012 9.32289C8.15626 9.16871 8.13955 8.99906 8.17211 8.83539C8.20466 8.67172 8.28502 8.52138 8.40302 8.40338C8.52102 8.28538 8.67136 8.20502 8.83504 8.17246C8.99871 8.13991 9.16836 8.15662 9.32253 8.22048C9.47671 8.28434 9.60848 8.39248 9.70119 8.53124C9.79391 8.66999 9.84339 8.83312 9.84339 9C9.84339 9.22378 9.7545 9.43839 9.59626 9.59662C9.43803 9.75486 9.22342 9.84375 8.99964 9.84375ZM12.0934 9.84375C11.9265 9.84375 11.7634 9.79426 11.6246 9.70155C11.4859 9.60884 11.3777 9.47706 11.3139 9.32289C11.25 9.16871 11.2333 8.99906 11.2659 8.83539C11.2984 8.67172 11.3788 8.52138 11.4968 8.40338C11.6148 8.28538 11.7651 8.20502 11.9288 8.17246C12.0925 8.13991 12.2621 8.15662 12.4163 8.22048C12.5705 8.28434 12.7022 8.39248 12.7949 8.53124C12.8877 8.66999 12.9371 8.83312 12.9371 9C12.9371 9.22378 12.8482 9.43839 12.69 9.59662C12.5318 9.75486 12.3172 9.84375 12.0934 9.84375Z'
      fill='#ffffff'
    />
  </svg>
);

const firstNameOf = (name) => (name || '').trim().split(/\s+/)[0] || '';

const storyParagraphs = (story) => {
  if (Array.isArray(story)) return story.filter(Boolean);
  if (typeof story === 'string') {
    return story
      .split(/\n+/)
      .map((paragraph) => paragraph.trim())
      .filter(Boolean);
  }
  return [];
};

// The "You've been matched" mentor card from the v2 mentor match design.
// Extracted from SignupMentorMatch so it can be reused verbatim anywhere a
// pixel-accurate mentor card is needed outside the full match/search flow
// (e.g. the admin mentor onboarding live preview).
const MatchedMentorCard = ({ mentor, matchedTitle = "You've been matched", continueLabel, onContinue, onClose }) => {
  const firstName = firstNameOf(mentor?.name);
  const paragraphs = storyParagraphs(mentor?.story);
  const ctaLabel = continueLabel || (firstName ? `Chat with ${firstName}` : 'Start chatting');
  const storyRef = useRef(null);
  const [canScrollDown, setCanScrollDown] = useState(false);

  useEffect(() => {
    const updateScrollFade = () => {
      const el = storyRef.current;
      if (!el) return;
      setCanScrollDown(el.scrollHeight - el.scrollTop - el.clientHeight > 8);
    };

    updateScrollFade();

    const el = storyRef.current;
    if (!el) return undefined;

    el.addEventListener('scroll', updateScrollFade, { passive: true });
    const resizeObserver = new ResizeObserver(updateScrollFade);
    resizeObserver.observe(el);

    return () => {
      el.removeEventListener('scroll', updateScrollFade);
      resizeObserver.disconnect();
    };
  }, [paragraphs.length, mentor?.story]);

  if (!mentor) return null;

  return (
    <div className={styles.card} role='dialog' aria-label={matchedTitle}>
      <header className={styles.cardHeader}>
        <span className={styles.cardHeaderTitle}>
          <MatchedHeaderSparkleIcon />
          <span className={styles.cardHeaderTitleText}>{matchedTitle}</span>
        </span>
        {onClose && (
          <button type='button' className={styles.cardClose} onClick={onClose} aria-label='Close'>
            <CloseIcon />
          </button>
        )}
      </header>

      <div className={styles.cardBody}>
        <aside className={styles.cardAside}>
          <div className={styles.cardPhoto}>
            {mentor.photoUrl ? (
              <img src={mentor.photoUrl} alt={mentor.name} className={styles.cardPhotoImg} />
            ) : (
              <span className={styles.cardPhotoPlaceholder} aria-hidden='true'>
                {(firstName || '?').charAt(0).toUpperCase()}
              </span>
            )}
            <span className={styles.verifiedPill}>
              <VerifiedMentorIcon />
              <span className={styles.verifiedLabel}>Verified mentor</span>
            </span>
          </div>
          <div className={styles.cardIdentity}>
            <h2 className={styles.cardName}>
              {mentor.name}
              {mentor.state && <span className={styles.cardNameState}>{mentor.state}</span>}
            </h2>
            {mentor.meta && <p className={styles.cardMeta}>{mentor.meta}</p>}
          </div>
        </aside>

        <div className={styles.cardMain}>
          <div className={styles.cardStoryWrap}>
            <div ref={storyRef} className={styles.cardStory}>
              {firstName && <p className={styles.cardStoryEyebrow}>{firstName}'s story</p>}
              {paragraphs.map((paragraph, i) => (
                <p key={i} className={styles.cardStoryText}>
                  {paragraph}
                </p>
              ))}
            </div>
            {canScrollDown && <div className={styles.cardStoryFade} aria-hidden='true' />}
          </div>
          <footer className={styles.cardFooter}>
            <button type='button' className={styles.cardCta} onClick={onContinue}>
              <ChatIcon className={styles.cardCtaIcon} />
              {ctaLabel}
            </button>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default MatchedMentorCard;
